import React from "react";

const Header = () => {
  return (
    <div className="col s12 l3 m4 valign-wrapper" id="navigator_wrap">
      <img src="https://s3-ap-southeast-1.amazonaws.com/edgedigital.sg/tuckandrose/Design/Images/mobile/m-flower-1.png" className="n-flower-1 n-flower" alt="" />
      <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flower-2.png" className="n-flower-4 n-flower hide-on-med-and-up" alt="" />
      <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flower-5.png" className="n-flower-5 n-flower hide-on-med-and-up" alt="" />
      <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flower-1.png" className="n-flower-6 n-flower hide-on-med-and-up" alt="" />
      
      <div id="left-header-wrapper">
      <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flower-3.png" className="n-flower-2 n-flower" alt="" />
      <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/flower-6.png" className="n-flower-3 n-flower" alt="" />
      <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/leaf-1.png" className="n-leaf-1 n-flower" alt="" />
      <div className="top-content"></div>
        <div className="side-content">
          <div id="logo" className="center">
            <img src="https://d4z29m2k6uqi4.cloudfront.net/tuckandrose/Design/Images/tr-element.png" width="80%" alt="" />
          </div>
          <div className="center">
            <p>
            Welcome to our photostream, and thank you very much for joining us in our wedding. This photostream wall is a prototype developed by Edge Digital. 
            </p>
            <img src="https://s3-ap-southeast-1.amazonaws.com/edgedigital.sg/tuckandrose/Design/Images/sm-top-tr-element.png" width="100%" alt="" />
            <p>
            Would you please share a photo and your thoughts with us? Snap a picture, write your thoughts, and share it for everyone to see!
            </p>
            <img src="https://s3-ap-southeast-1.amazonaws.com/edgedigital.sg/tuckandrose/Design/Images/sm-bottom-tr-element.png" width="100%" alt="" />
          </div>
        </div>
        <div className="bottom-content hide-on-small-only"></div>
      </div>
    </div>
  );
};
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js